// extracted by css-extract-rspack-plugin
export default {"root":"M8ta1m","theme-based":"x7SsLL","themeBased":"x7SsLL","content":"e2EaM8"};